<template>
  <div>
    <h1>Add a Subscription</h1>

    <h2>Plan Details</h2>
    <VAsync :await="plansReq">
      <template #pending><PLoader /></template>

      <template #resolved>
        <p>
          Name: {{ plans[0].nickname }}
          <br />
          {{ (plans[0].amount / 100) | currency }}/month
        </p>
      </template>
    </VAsync>

    <h2>Payment Method:</h2>
    <VAsync :await="request">
      <template #pending><PLoader /></template>

      <template #resolved>
        <VForm v-if="!paymentMethods.length" @submit.prevent="onAddMethod">
          <template #default="form">
            <VInput
              name="number"
              label="Card Number"
              required
              minlength="15"
              maxlength="16"
              inputmode="numeric"
            />
            <VInput
              name="exp_month"
              label="Expiration Month"
              required
              minlength="1"
              maxlength="2"
              inputmode="numeric"
            />
            <VInput
              name="exp_year"
              label="Expiration Year"
              required
              minlength="2"
              maxlength="4"
              inputmode="numeric"
            />
            <VInput
              name="cvc"
              label="CVC"
              required
              minlength="3"
              maxlength="4"
              inputmode="numeric"
            />

            <button type="submit" :disabled="!form.valid">
              Submit
            </button>
          </template>
        </VForm>

        <VForm v-else @submit.prevent="sendPayment">
          <template #default="form">
            <VInput
              :value="selectedMethod.id"
              type="select"
              label="Saved card"
              :options="paymentMethods"
              @change="selectedMethod = $event.target.value"
              required
              class="mb-4"
            />

            <button type="submit" :disabled="!form.valid">
              Submit
            </button>
          </template>
        </VForm>
      </template>
    </VAsync>
  </div>
</template>

<script>
// @ts-check
import { API } from "../config"
import store from "../store"
import stripe from "../stripe"
import http from "../http"

export default {
  data: () => ({
    plansReq: null,
    request: null,

    plans: [],

    paymentMethods: [],
    selectedMethod: null,

    payRequest: null,
  }),

  computed: {
    auth: store.get.auth,
  },

  mounted() {
    this.plansReq = this.getPlans()
    this.request = this.getPayMethods()
  },

  methods: {
    getPlans() {
      return http.get(`${API}/plans`).then(res => {
        this.plans = res.data
      })
    },
    getPayMethods() {
      return http
        .get(`${API}/payment-methods`, {
          headers: {
            Authorization: `Bearer ${this.auth.token}`,
          },
        })
        .then(res => {
          this.paymentMethods = res.data.map(method => {
            return {
              label: `Card ending in ${method.card.last4}`,
              value: method.id,
            }
          })
          if (res.data.length) {
            this.selectedMethod = res.data[0].id
          }
          return res
        })
    },

    onAddMethod({ target }) {
      const { auth } = this
      const data = new FormData(target)
      const cc = Object.fromEntries(data)

      this.request = async () => {
        const token = await http.post(`${API}/payment-methods`, {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
          data: cc,
        })
        // console.log(token);
        return this.getPayMethods()
      }
    },

    sendPayment({ target }) {
      const { auth, plans } = this
      const plan = plans[0].id

      this.request = http
        .post(`${API}/subscribe`, {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
          data: { plan, paymentMethod: this.selectedMethod },
        })
        .then(() => {
          this.$router.push({ name: "Dashboard" })
        })
    },
  },
}
</script>
